import script from "./examQuestionDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./examQuestionDetails.vue?vue&type=script&lang=ts&setup=true"

import "./examQuestionDetails.vue?vue&type=style&index=0&id=191081c7&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191081c7"]])

export default __exports__